import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(function () {
	$w("#hepiVectorImage").link = "/home"
    $w("#hepiVectorImage").src = "https://static.wixstatic.com/shapes/109495_fd6124cc37984183b4325d568bbbf8d6.svg"
	
    if(wixWindow.formFactor === "Mobile"){
		$w("#menuToggle1").show()
	} else {
		$w("#searchBox").show()
		$w("#horizontalMenu1").show()
	}
});

export function headerButton_click(event) {
    wixLocation.to("/home")
}
	